import * as React from 'react';
import get from 'lodash/get';
import styles from './NotificationBell.css';
import getImageUrl from 'utils/getImageUrl';
import { CheckBoxStatus } from '@rome/response/common/leaf/value/CheckBoxStatus';
const GRID_WIDTH = 264;
const GRID_HEIGHT = 264;
const SLICES = 3;
const CELL_WIDTH = GRID_WIDTH / SLICES;
const CELL_HEIGHT = GRID_HEIGHT / SLICES;
const DIMENSION_MULTIPLIER = !__SERVER__ && window.devicePixelRatio ? window.devicePixelRatio : 2;
export default class NotificationBellImage extends React.PureComponent {
    getImageUrl(slotIndex) {
        const params = get(this.props, 'widgetData.params');
        const header = get(this.props, 'widgetData.header');
        const isBlocked = get(params, 'isBlocked');
        const showHeader = get(header, 'value.showHeader');
        const items = get(this.props, 'items', []);
        const someChecked = items.some(item => {
            const status = get(item, 'value.checkbox.value.status');
            return item.parentIndex === -1 && (status === CheckBoxStatus.SELECTED || status === CheckBoxStatus.PARTIAL);
        });
        const imageWidth = Math.round(CELL_WIDTH * DIMENSION_MULTIPLIER).toString();
        switch (slotIndex) {
            case 0:
            case 1:
            case 2:
            case 6:
            case 7:
            case 8: {
                const tabItem = items.find(item => {
                    return item.hasChildren && get(item, 'value.imageSlotPosition') === slotIndex;
                });
                // TODO: selectedStatus should be the overall selection status considering its children items
                const selectedStatus = get(tabItem, 'value.checkbox.value.status');
                return (selectedStatus === 'SELECTED' || selectedStatus === 'PARTIAL') && !isBlocked
                    ? getImageUrl(get(tabItem, 'value.image.dynamicImageUrl'), imageWidth, '100')
                    : getImageUrl(get(tabItem, 'value.greyedImage.dynamicImageUrl'), imageWidth, '100');
            }
            case 3:
                return !isBlocked && !showHeader && someChecked && getImageUrl(get(params, 'leftStarUrl'), imageWidth, '100');
            case 4: {
                return isBlocked
                    ? getImageUrl(get(params, 'redBellUrl'), imageWidth, '100')
                    : !someChecked || (showHeader && !someChecked)
                        ? getImageUrl(get(params, 'greyBellUrl'), imageWidth, '100')
                        : getImageUrl(get(params, 'blueBellUrl'), imageWidth, '100');
            }
            case 5:
                return !isBlocked && !showHeader && someChecked && getImageUrl(get(params, 'rightStarUrl'), imageWidth, '100');
            default:
                return undefined;
        }
    }
    renderImages() {
        const images = [];
        for (let i = 0; i < SLICES; i++) {
            for (let j = 0; j < SLICES; j++) {
                const index = j + i * SLICES;
                const imageUrl = this.getImageUrl(index);
                images.push(imageUrl ? (<img key={index} src={imageUrl} style={{ width: CELL_WIDTH, height: CELL_HEIGHT }}/>) : (<div key={index} className={styles['placeholder-img']}/>));
            }
        }
        return images;
    }
    render() {
        return (<div className={styles.container} style={{ width: GRID_WIDTH, height: GRID_HEIGHT }}>
				{this.renderImages()}
			</div>);
    }
}
